document.addEventListener('DOMContentLoaded', () => {
  const accordionDetails = document.querySelectorAll('.accordion details');

  accordionDetails.forEach((detail, index) => {
    if (index === 0) {
      detail.style.display = 'none';
      return;
    }

    const summary = detail.querySelector('summary');
    const content = detail.querySelector(':scope > *:not(summary)');

    // Initialize maxHeight and open state
    content.style.maxHeight = '0px';
    content.style.overflow = 'hidden';

    summary.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent default toggle behavior of <details>

      const isOpen = detail.hasAttribute('open');

      // Close all other details
      accordionDetails.forEach((otherDetail) => {
        if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
          const otherContent = otherDetail.querySelector(':scope > *:not(summary)');
          otherContent.style.maxHeight = '0px';
          otherContent.addEventListener(
            'transitionend',
            () => {
              otherDetail.removeAttribute('open');
            },
            { once: true }
          );
        }
      });

      // Toggle the current detail
      if (isOpen) {
        content.style.maxHeight = '0px';
        content.addEventListener(
          'transitionend',
          () => {
            detail.removeAttribute('open');
          },
          { once: true }
        );
      } else {
        detail.setAttribute('open', '');
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    });
  });
});